import $ from 'jquery';
import responsive from 'lib/responsive';

// This file handles the new toggle in /templatedata/BAT/Carousel_2/data DCRs
// that turns on/off the carousel site-wide
export default {

  handleCarouselToggle: function (carouselToggleDesktop, carouselToggleMobile) {
    var self = this;
    if (carouselToggleDesktop && carouselToggleDesktop === 'off') {
      self.hideCarouselForDesktop();
    }

    if (carouselToggleMobile && carouselToggleMobile === 'off') {
      self.hideCarouselForMobile();
    }
  },

  /** Hides the carousel for desktop if the carouselToggleDesktop node equals 'on' */
  hideCarouselForDesktop: function () {
    if (responsive() !== 'sm') {
      var heightPadding = '200px'; // this is subjective and may need tweaking, 200px looked right at the time

      // when the carousel is hidden, use this empty space buffer to shift things down some,
      // this way the region plaque and offers/modules are not so scrunched, this is also intuitive
      // as is looks weird without this buffer
      var spaceBuffer = '<div style="height:' + heightPadding + '; width:100%; clear:both;"></div>';
      $('.main-header-offers.js-offers-header').hide().before(spaceBuffer);
    }
  },

  /**
   * Hides the carousel for mobile only if the carouselToggleMobile node equals 'on'
   *
   * there is not a separate mobile carousel, only a responsive one, so use responsive()
   * to determine whether or not to hide, as the requirements called for mobile and desktop
   * to have separate toggles
   */
  hideCarouselForMobile: function () {
    if (responsive() === 'sm') {
      var heightPadding = '10px'; // height padding is different for mobile (also subjective)
      var spaceBuffer = '<div style="height:' + heightPadding + '; width:100%; clear:both;"></div>';
      $('.main-header-offers.js-offers-header').hide().before(spaceBuffer);
    }
  },
};
